var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "115", height: "102", viewBox: "0 0 115 102", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "pending"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement("circle", { id: "a", cx: "58", cy: "44", r: "40" }),
      React.createElement(
        "filter",
        { x: "-11.9%", y: "-9.4%", width: "123.8%", height: "123.8%", filterUnits: "objectBoundingBox", id: "b" },
        React.createElement("feMorphology", { radius: "1", operator: "dilate", "in": "SourceAlpha", result: "shadowSpreadOuter1" }),
        React.createElement("feOffset", { dy: "2", "in": "shadowSpreadOuter1", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { stdDeviation: "2.5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
        React.createElement("feComposite", { "in": "shadowBlurOuter1", in2: "SourceAlpha", operator: "out", result: "shadowBlurOuter1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0", "in": "shadowBlurOuter1" })
      ),
      React.createElement("rect", { id: "d", x: "10", y: "61", width: "95", height: "27", rx: "4" }),
      React.createElement(
        "filter",
        { x: "-17.9%", y: "-48.1%", width: "135.8%", height: "225.9%", filterUnits: "objectBoundingBox", id: "c" },
        React.createElement("feOffset", { dy: "4", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { stdDeviation: "5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
        React.createElement("feComposite", { "in": "shadowBlurOuter1", in2: "SourceAlpha", operator: "out", result: "shadowBlurOuter1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0", "in": "shadowBlurOuter1" })
      )
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("use", { fill: "#000", filter: "url(#b)", xlinkHref: "#a" }),
      React.createElement("circle", { stroke: "#60BFB5", fill: "#DCF0EE", cx: "58", cy: "44", r: "40.5" }),
      React.createElement("path", { d: "M73.57 50.781h-6.047l-3.984-4.453c-1.203 1.297-1.805 2.14-1.805 2.531 0 .704.368 1.055 1.102 1.055v.867h-5.813v-.867c.844-.047 1.672-.43 2.485-1.148.812-.72 1.89-1.836 3.234-3.352l-8.46-9.469h-3.259v8.742c0 1.579.063 2.692.188 3.34.125.649.465 1.125 1.02 1.43.554.305 1.496.457 2.824.457v.867H42v-.867c1.484 0 2.535-.152 3.152-.457.618-.305.996-.781 1.137-1.43.14-.648.211-1.761.211-3.34V25.095c0-1.578-.07-2.692-.21-3.34-.142-.649-.52-1.125-1.138-1.43-.617-.304-1.668-.457-3.152-.457V19h13.781c3.657 0 6.41.793 8.262 2.379 1.852 1.586 2.777 3.543 2.777 5.871 0 2.031-.695 3.754-2.086 5.168-1.39 1.414-3.32 2.387-5.789 2.918l6.47 7.008c1.405-1.625 2.108-2.672 2.108-3.14 0-.767-.554-1.15-1.664-1.15v-.867h7.243v.868c-.875 0-1.75.27-2.625.808-.875.54-2.29 1.98-4.243 4.325l4.688 5.062c.64.703 1.523 1.258 2.648 1.664v.867zm-22.547-16.36h1.055c2.89 0 5.172-.597 6.844-1.792 1.672-1.195 2.508-2.918 2.508-5.168 0-1.953-.602-3.563-1.805-4.828-1.203-1.266-2.758-1.899-4.664-1.899-.719 0-2.031.141-3.938.422v13.266z", fill: "#212121" }),
      React.createElement("use", { fill: "#000", filter: "url(#c)", xlinkHref: "#d" }),
      React.createElement("rect", { stroke: "#F78C4E", strokeWidth: ".8", strokeLinejoin: "square", fill: "#FFF", x: "10.4", y: "61.4", width: "94.2", height: "26.2", rx: "4" }),
      React.createElement(
        "text",
        { fontFamily: "SoleilBk, Soleil", fontSize: "12", fontWeight: "300", letterSpacing: ".2", fill: "#F78C4E" },
        React.createElement(
          "tspan",
          { x: "30", y: "79" },
          "PENDING"
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/pending.svg